module.exports = __webpack_public_path__ + "img/shortcode_hifi_3.537d0ffc.png";